import Components from "../components";

class BacktraceStyleSwitcher extends Components.Base {
  bind() {
    this.on('click.backtrace', '.nav-link', this.saveTraceSelection);
  }

  initialize() {
    const targetId = $.cookie('traceStyle');
    if (targetId) {
      try {
        $(`a[href=${targetId}]`).click();
      } catch (error) {
        // Swallowing error prevents bad targetIds from halting script execution
      }
    }
  }

  saveTraceSelection(e) {
    return $.cookie('traceStyle', e.target.getAttribute('href'), {
      expires: 365,
      path: '/',
    });
  }
}

Components.collection.register({
  selector: '.c-backtrace-style-switcher',
  klass: BacktraceStyleSwitcher,
});
